export class LocalStorage {
  static get(key, emptyValue = null) {
    try {
      const value = localStorage.getItem(key);
      if (value === null) {
        return emptyValue;
      }
      return JSON.parse(value);
    } catch {
      return emptyValue;
    }
  }

  static set(key, value) {
    const stringValue = JSON.stringify(value);
    localStorage.setItem(key, stringValue);
  }
}

export default LocalStorage;
